import type { LinkProps } from '@ab-core/link';
import type { FavoriteItemType } from './types';
import { useGetFavoriteList } from './utils';

type CommercialFavoriteItemType = FavoriteItemType & { urlTarget?: LinkProps['target'] };

type ReturnType = {
    favoriteList: Array<FavoriteItemType>;
    commercialFavoriteList: Array<CommercialFavoriteItemType>;
};

export const useGetFavoriteItems = (): ReturnType => {
    const favoriteList = useGetFavoriteList();
    const commercialFavoriteList: Array<CommercialFavoriteItemType> = [
        {
            name: '125 Jahre',
            url: 'https://web.alexander-buerkle.com/de/jubilaeumsaktion',
            icon: 'Label',
            urlTarget: '_blank'
        },
        { name: 'electra2025', url: 'https://electra-messe.de/', icon: 'Elephant', urlTarget: '_blank' }
    ];

    return {
        favoriteList,
        commercialFavoriteList
    };
};
